<template>
  <div class="apple-ios-site">
    <!-- Apple Header with Global & Sub-Nav -->
    <AppleNav />

    <!-- Main Presentation Sections -->
    <main class="main-content">
      <!-- Hero Section: iPhone 18 & iOS 18 Overview -->
      <HeroSection />

      <div class="sections-frame">
        <!-- All-New iPhone Fold Section -->
        <IPhoneFoldSection />

        <!-- Promo Grid Section: AirPods 5 & MacBook Air -->
        <PromoSplitGrid />
      </div>

      <!-- Content wrapper with clean white margin framing -->
      <div class="sections-frame">
   

        <!-- Bento Grid of Key Features -->
        <FeatureGrid />

        <!-- Device Compatibility Matrix & Update Guide -->
      </div>
    </main>

    <!-- Apple Directory Footer -->
    <AppleFooter />
  </div>
</template>

<script>
import AppleNav from '@/components/AppleNav.vue';
import HeroSection from '@/components/HeroSection.vue';
import IPhoneFoldSection from '@/components/IPhoneFoldSection.vue';
import PromoSplitGrid from '@/components/PromoSplitGrid.vue';
import AppleIntelligenceSection from '@/components/AppleIntelligenceSection.vue';
import CustomizationSection from '@/components/CustomizationSection.vue';
import PhotosSection from '@/components/PhotosSection.vue';
import MessagesSection from '@/components/MessagesSection.vue';
import FeatureGrid from '@/components/FeatureGrid.vue';
import CompatibilitySection from '@/components/CompatibilitySection.vue';
import AppleFooter from '@/components/AppleFooter.vue';

export default {
  name: 'HomeView',
  components: {
    AppleNav,
    HeroSection,
    PromoSplitGrid,
    AppleIntelligenceSection,
    IPhoneFoldSection,
    CustomizationSection,
    PhotosSection,
    MessagesSection,
    FeatureGrid,
    CompatibilitySection,
    AppleFooter
  }
}
</script>

<style scoped>
.apple-ios-site {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  background-color: #ffffff;
  color: var(--text-color);
  position: relative;
}

.main-content {
  flex: 1;
  width: 100%;
  background-color: #ffffff;
}

.sections-frame {
  background-color: #ffffff;
  overflow: hidden;
}

@media (max-width: 768px) {
  .sections-frame {
    margin: 16px auto 0;
  }
}
</style>
